import I18n from 'js/lib/i18n.js.erb'
import { createFlash } from 'components/flash/component'
;(function ($) {
  $(document).on('ajax:success', '.notification--body_container.listing_adopted .action', function () {
    createFlash('notice', I18n.t('notifications.listing_adopted.flash.success'))
  })
})(jQuery)
